export default {
    signature: null,
    content: null,
    term: null,
    teacher: null,
    institution: null,
    loading: false,
    error: null,
}
